<nb-tabset>
  <nb-tab tabTitle="Consulta" tabIcon="search-outline" responsive style="height: 80vh;">
    <app-spinner class="col-8 float-right" *ngIf="showSpinnerConsulta"></app-spinner>
      <div *ngIf="showGrillaConsulta" class="col-8 float-right">
        <angular-slickgrid gridId="gridId" [columnDefinitions]="columnDefinitionsConsulta" [gridOptions]="gridOptionsConsulta"
          [dataset]="datasetConsulta" gridHeight="380" (onAngularGridCreated)="angularGridReadyConsulta($event)">
        </angular-slickgrid>
      </div>
  </nb-tab>
  <nb-tab tabTitle="Alta" tabIcon="upload-outline" responsive style="height: 80vh;">
    <div class="row">
      <div class="col-4 float-left">
        <p class="Titulo">Valorización - Alta </p>
        <p>
          <p-dropdown required class="limited-selector" id="inputOperador" placeholder="Operador"
            [style]="{'width':'100%','margin-bottom':'10px'}" [options]="operadores" [(ngModel)]="operadorSeleccionado"
            [virtualScroll]="true" [itemSize]="31" [filter]="true"
            [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}">
          </p-dropdown>
        </p>
        <p>
          <p-dropdown required class="limited-selector" id="inputAveria" placeholder="Tipo Avería"
            [(ngModel)]="tipoAveriaSeleccionada" [style]="{'width':'100%','margin-bottom':'10px'}" [options]="tipo"
            [virtualScroll]="true" [itemSize]="31" [filter]="true"
            [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}">
          </p-dropdown>
        </p>
        <p>
          <p-dropdown required class="limited-selector" id="inputSeveridad" placeholder="Severidad"
            [(ngModel)]="severidadSeleccionada" [style]="{'width':'100%','margin-bottom':'10px'}" [options]="severidad"
            [virtualScroll]="true" [itemSize]="31" [filter]="true"
            [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}">
          </p-dropdown>
        </p>
        <p>
          <mat-form-field class="altaLabel" style="width: 100%; margin-top: -5px;">
            <mat-label>Valor</mat-label>
            <input matInput #message2 [type]="" name="valor" [(ngModel)]="valorSeleccionado">
          </mat-form-field>
        </p>
        <p>
          <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>
          <button nbButton size="tiny" style="float: right;" class="buttontz col-4" (click)="traerDatosValorizacion()">
            Guardar</button>
        </p>
      </div>
      <app-spinner class="col-8 float-right" *ngIf="showSpinner"></app-spinner>
      <div *ngIf="showGrilla" class="col-8 float-right">
        <angular-slickgrid gridId="gridId" [columnDefinitions]="columnDefinitions" [gridOptions]="gridOptions"
          [dataset]="dataset" gridHeight="380" (onAngularGridCreated)="angularGridReady($event)">
        </angular-slickgrid>
      </div>
    </div>
  </nb-tab>
  <nb-tab tabTitle="Modificación" tabIcon="edit-outline" responsive style="height: 80vh;">
    <div class="row">
      <div class="col-4 float-left">
        <p class="Titulo">Valorización - Modificación </p>
        <p>
          <p-dropdown required class="limited-selector" id="inputOperador" placeholder="Operador"
            [style]="{'width':'100%','margin-bottom':'10px'}" [options]="operadores" [(ngModel)]="operadorEditar"
            [virtualScroll]="true" [itemSize]="31" [filter]="true"
            [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}">
          </p-dropdown>
        </p>
        <p>
          <p-dropdown required class="limited-selector" id="inputAveria" placeholder="Tipo Avería"
            [(ngModel)]="tipoAveriaEditar" [style]="{'width':'100%','margin-bottom':'10px'}" [options]="tipo"
            [virtualScroll]="true" [itemSize]="31" [filter]="true"
            [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}">
          </p-dropdown>
        </p>
        <p>
          <p-dropdown required class="limited-selector" id="inputSeveridad" placeholder="Severidad"
            [(ngModel)]="severidadEditar" [style]="{'width':'100%','margin-bottom':'10px'}" [options]="severidad"
            [virtualScroll]="true" [itemSize]="31" [filter]="true"
            [ngClass]="{'form-control-danger': firstForm.invalid && (firstForm.dirty || firstForm.touched)}">
          </p-dropdown>
        </p>
        <p>
          <mat-form-field class="altaLabel" style="width: 100%; margin-top: -5px;">
            <mat-label>Valor</mat-label>
            <input matInput #message2 [type]="" name="valor" [(ngModel)]="valorEditar">
          </mat-form-field>
        </p>
        <p>
          <app-spinner *ngIf="showSpinnerGuardar"></app-spinner>
          <button nbButton size="tiny" style="float: right;" class="buttontz col-4" >
            Guardar</button>
        </p>
      </div>
    </div>
  </nb-tab>
</nb-tabset>